import { call, delay, fork, put, select, takeEvery, takeLatest } from "typed-redux-saga";
import { hasValue } from "@advosys/component-react-utils";
import { getAuthService, initAuthServiceAsync } from "src/backend/msal/auth-manager";
import { actions, AuthenticationActionTypes } from "./authentication-store";
function* login() {
    const authService = yield* call(getAuthService);
    yield* call(authService.signIn.bind(authService));
}
function* watchLoginRequest() {
    yield* takeEvery(AuthenticationActionTypes.LoginRequest, login);
}
function* authenticate() {
    const tenantId = yield* select((state) => state.authentication.authentication.tenantId);
    if (!hasValue(tenantId)) {
        yield* put(actions.loginFail("TenantId needs to be set before authenticating."));
        return;
    }
    yield* call(initAuthServiceAsync, tenantId);
    const authService = yield* call(getAuthService);
    const result = yield* call(authService.handleRedirect.bind(authService));
    if (result?.account) {
        const tokenResult = yield* call(authService.getAccessToken.bind(authService));
        if (tokenResult?.accessToken) {
            yield* put(actions.loadTokenFromStorageRequest(tokenResult.accessToken, tokenResult.expiresOn, result.account));
        }
        else {
            yield* put(actions.loginFail("Failed to acquire access token."));
        }
    }
    else {
        yield* put(actions.loginRequest());
    }
}
function* watchAuthenticate() {
    yield* takeEvery(AuthenticationActionTypes.AuthenticateRequest, authenticate);
}
function* loadTokenFromStorage(action) {
    yield* put(actions.loadTokenFromStorageSuccess(action.payload.accessToken, action.payload.account));
    yield* put(actions.startRefreshTokenTimer(action.payload.expiresOn));
}
function* watchLoadTokenFromStorageRequest() {
    yield* takeEvery(AuthenticationActionTypes.LoadTokenFromStorageRequest, loadTokenFromStorage);
}
function* tokenRefresh() {
    const authService = yield* call(getAuthService);
    try {
        const tokenResult = yield* call(authService.getAccessToken.bind(authService));
        if (!tokenResult)
            throw new Error("No token result");
        yield* put(actions.refreshTokenSuccess(tokenResult.accessToken, tokenResult.account));
        yield* put(actions.startRefreshTokenTimer(tokenResult.expiresOn));
    }
    catch {
        yield* put(actions.refreshTokenFail("Token couldn't be renewed."));
        yield* put(actions.loginRequest());
        yield* call(authService.signIn.bind(authService));
    }
}
function* watchTokenRefreshRequest() {
    yield* takeEvery(AuthenticationActionTypes.TokenRefreshRequest, tokenRefresh);
}
function* startRefreshTokenTimer(action) {
    const expiresOn = action.payload.expiresOn;
    if (!expiresOn) {
        yield* put(actions.refreshTokenRequest());
        return;
    }
    const currentTime = Date.now();
    const expires = expiresOn.getTime();
    const refreshAt = expires - (expires - currentTime) / 2;
    const refreshIn = refreshAt - currentTime;
    if (refreshIn < 1) {
        yield* put(actions.refreshTokenRequest());
        return;
    }
    yield* delay(refreshIn);
    yield* put(actions.refreshTokenRequest());
}
function* watchStartRefreshTokenTimerRequest() {
    yield* takeLatest(AuthenticationActionTypes.StartRefreshTokenTimer, startRefreshTokenTimer);
}
function* logout() {
    yield* put(actions.logoutSuccess());
    const authService = yield* call(getAuthService);
    yield* call(authService.logout.bind(authService));
}
function* watchLogoutRequest() {
    yield* takeEvery(AuthenticationActionTypes.LogoutRequest, logout);
}
export const authenticationSagaInit = () => [
    fork(watchLoginRequest),
    fork(watchAuthenticate),
    fork(watchLoadTokenFromStorageRequest),
    fork(watchTokenRefreshRequest),
    fork(watchStartRefreshTokenTimerRequest),
    fork(watchLogoutRequest)
];
